import { Spinner, Stack } from '@servicetitan/design-system';

interface LoadingOverlayProps {
  loading: boolean;
  children: React.ReactNode | React.ReactNode[];
}

const LoadingOverlay = ({ children, loading }: LoadingOverlayProps) => {
  return (
    <div className='position-relative w-100 h-100'>
      {loading && (
        <div className='position-absolute h-100 w-100 opacity-disabled cursor-not-allowed bg-neutral-400 z-overlay'>
          <Stack
            className='h-100 w-100'
            justifyContent='center'
            alignItems='center'
          >
            <Spinner size='large' />
          </Stack>
        </div>
      )}
      {children}
    </div>
  );
};

export default LoadingOverlay;
